<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="620px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <v-toolbar-title>XÁC NHẬN THAO TÁC</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <p class="ma-0">
            Thao tác này sẽ sắp xếp tất cả học sinh vào phòng thi từ đầu.<br />
            Bạn có chắc là bạn muốn thực hiện thao tác không?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm()">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="progressDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>Đang xử lý</v-card-title>
        <v-card-text>
          <v-progress-linear :value="progress" color="blue darken-4" stream></v-progress-linear>
          <div class="progress-text">{{ formattedProgress }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { StudentExam } from '../../plugins/api'
import { mapActions } from 'vuex'
export default {
  props: {
    exam: String,
    state: Boolean
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      progressDialog: false,
      alertShown: false,
      progress: 0,
      formattedProgress: ''
    }
  },
  methods: {
    ...mapActions('examRoom', ['fetchExamRooms', 'updateExamRoom']),
    cancel() {
      this.$emit('closeDialog')
    },
    async confirm() {
      this.$loading.active = true
      const indexing = await StudentExam.autoAssignRooms({ exam: this.exam })

      if (indexing) {
        await this.getProgress()
      } else {
        this.$alert.error('Lỗi đánh số báo danh')
        this.cancel()
      }
      this.$loading.active = false
    },
    async getProgress() {
      this.progressDialog = true
      this.updateProgress()
      this.progressInterval = setInterval(() => {
        this.updateProgress()
      }, 5000)
    },

    async updateProgress() {
      const progressData = await this.fetchExamRooms({ exam: this.exam })
      const { process, processedStudent, totalStudent, status, type } = progressData[0]

      this.progress = process
      console.log(this.progress)
      if (status === 'available') {
        this.progress = 0
        this.alertShown = false
      } else if (status === 'processing') {
        if (type === 'empty' && !this.alertShown) {
          this.$alert.warn('Xin vui lòng đợi để thao tác cũ thực hiện xong')
          this.alertShown = true
        }
        this.formattedProgress = `Đang xử lý ${processedStudent}/${totalStudent} học sinh`
      } else if (status === 'finish') {
        this.$loading.active = true
        await this.updateExamRoom({ id: progressData[0].id, status: 'available' })
        this.formattedProgress = ''

        clearInterval(this.progressInterval)
        this.progressDialog = false
        this.$alert.success('Xếp phòng cho toàn bộ học sinh thành công')
        this.$emit('refresh')
        this.cancel()
      }
    }
  },

  destroyed() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval)
    }
  }
}
</script>
<style scoped>
.progress-text {
  text-align: center;
  margin-top: 10px;
  font-family: 'Roboto';
}
</style>
